export default __webpack_public_path__ + "static/media/ic_document_icon.d4dae6dd.png";